export const systemConfig = {
    closeAutoRenewInArea: SERVER_LOCATION === 'in'
};
